export default __webpack_public_path__ + "static/media/gina.7791d2e6.png";